import { render } from "./UpdateEmailSettingView.vue?vue&type=template&id=dbc1172a"
import script from "./UpdateEmailSettingView.vue?vue&type=script&lang=js"
export * from "./UpdateEmailSettingView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__